
























  import { Component, Mixins } from 'vue-property-decorator'
  import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'
import userModule from '@/store/modules/UserModule'
import jwt_decode from 'jwt-decode'
import IToken from '@/models/IToken'

@Component
export default class Login extends Mixins(BaseVue) {
  public displayLoading = false

  public mounted () {
    this.Connect()
  }

  public async Connect () {
    this.displayLoading = true
    const token = localStorage.getItem('token')
    try {
      if (token !== null && token !== '') {
        const decodedToken = jwt_decode(token) as IToken
        const userId = Number.parseInt(decodedToken.user_id, 10)
        const realUserId = Number.parseInt(decodedToken.real_user_id, 10)
        const user = await serviceModule.userApi.getById(userId)
        userModule.setRealUserId(realUserId)
        this.$emit('connecte:valide', {
          token: token,
          user: user
        })
      } else {
        console.log('token =', token)
        this.redirectUserToAuth()
      }
    } catch (exception) {
      console.log('ex =', exception)
      this.redirectUserToAuth()
    }
  }

  public redirectUserToAuth (): Promise<any> {
    localStorage.removeItem('token')
    const baliseA = document.getElementById('urlAuth')
    if (baliseA) {
      baliseA.click()
      return Promise.resolve()
    } else {
      return Promise.reject(new Error('No balise <a> found'))
    }
  }

  public get URLLOGIN () {
    return `${process.env.VUE_APP_BACK_URL}/api/Saml/InitiateSingleSignOn?returnUrl=${window.location.href}`
  }

  public retryConnection () {
    this.Connect()
  }
  }
